import moment from "moment";
import { ServiceStatus } from "@/enums/ServiceStatus";
import Loader from "@/components/loader/Loader.vue";
import { FacilitySettingsModel } from "@/models/FacilitySettings";

export default {
  name: "ReportCommunityHealthDashboard",
  data() {
    return {
      period: "week",
      startDate: moment().subtract(1, "week").toISOString().substring(0, 10),
      endDate: moment().toISOString().substring(0, 10),
      loading: true,
      facilityReportData: null,
      eventServicesReportData: null,
      activitiesReportData: null,
      residentsReportData: null,
      familyMembersReportData: null,
      staffsReportData: null,
      serviceStatus: ServiceStatus,
      facilitiesResidents: [],
      facilitiesResidentsActivity: {},
      facilitiesLifestyleEvents: [],
      facilitiesLifestyleEventsPopular: [],
      periods: [
        { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Week"], value: "week" },
        { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Month"], value: "month" },
        { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Year"], value: "year" }
      ],
      picker: {
        start: false,
        end: false
      },
      headerServices: [
        {
          text: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Name"],
          value: "name",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Amount"],
          value: "amount",
        }
      ]
    }
  },
  components: {
    Loader
  },
  computed: {
    facility(): FacilitySettingsModel {
      return this.$store.state.facilityModule.selectedFacility;
    },
    facilities() {
      return this.$store.state.facilityModule.facilities;
    },
    facilitiesIds() {
      return this.$store.state.facilityModule.facilities.map(x => x.id);
    },
    formattedStartDate() {
      return moment(this.startDate).format(this.facility.dateFormat)
    },
    formattedEndDate() {
      return moment(this.endDate).format(this.facility.dateFormat)
    },
    servicesRequestsApproveCompleted() {
      return this.eventServicesReportData?.servicesRequestsApproveCompleted
    },
    servicesBooked() {
      return this.eventServicesReportData?.servicesBooked
    },
    mostPopularServices() {
      return this.eventServicesReportData?.mostPopularServices
    },
    leastPopularServices() {
      return this.eventServicesReportData?.leastPopularServices
    },
    eventsWithAttendees() {
      return this.eventServicesReportData?.eventsWithAttendees
    },
    mostPopularEvents() {
      return this.eventServicesReportData?.mostPopularEvents
    },
    leastPopularEvents() {
      return this.eventServicesReportData?.leastPopularEvents
    },
    numberOfFamilyHubUsers() {
      return this.familyMembersReportData?.numberOfFamilyHubUsers
    },
    numberOfFamilyHubUsersUsingFamilyHub() {
      return this.familyMembersReportData?.numberOfFamilyHubUsersUsingFamilyHub
    },
    numberOfStaffs() {
      return this.staffsReportData?.numberOfStaffs
    },
    mostPopularActivities() {
      return this.activitiesReportData?.mostPopularActivities
    },
    leastPopularActivities() {
      return this.activitiesReportData?.leastPopularActivities
    },
    numberOfActivities() {
      return this.activitiesReportData?.numberOfActivities
    },
    numberOfCreatedResidents() {
      return this.residentsReportData?.numberOfCreatedResidents
    },
    numberOfResidentsUsingMyHub() {
      return this.residentsReportData?.numberOfResidentsUsingMyHub
    },
  },
  methods: {
    routeToReports() {
      this.$router.push("/reports");
    },

    async loadReport() {
      this.facilityReportData = await this.$store.dispatch("getFacilityReportData", { facilityId: this.facility.id, startDate: moment(this.startDate).startOf('day').toDate(), endDate: moment(this.endDate).endOf('day').toDate() });
      this.activitiesReportData = await this.facilityReportData.activitiesReportAsync
      this.staffsReportData = await this.facilityReportData.staffsReportAsync
      this.familyMembersReportData = await this.facilityReportData.familyMembersReportAsync
      this.residentsReportData = this.facilityReportData.residentsReport
      this.eventServicesReportData = await this.facilityReportData.eventServicesReportAsync
    }
  },
  async created() {
    await this.$store.dispatch("getFacility");
    await this.loadReport();
    this.loading = false;
  }
}